import { render, staticRenderFns } from "./ZT_exchange_platform-modal.vue?vue&type=template&id=6398f8e0&scoped=true"
import script from "./ZT_exchange_platform-modal.vue?vue&type=script&lang=js"
export * from "./ZT_exchange_platform-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398f8e0",
  null
  
)

export default component.exports